// extracted by mini-css-extract-plugin
export default {"swiper":"aJHiZV","swiper--m":"lVRYn3","picture-wrapper":"H8Y8KR"};